export default __webpack_public_path__ + "static/media/DoNotSneeze_04.a7a9e520.png";